import { DATA_SOURCES } from '@/config/constants';
import EntityHeroCard from '../shared/entity/EntityHeroCard';
import { EntityInsightBar } from 'components/AiAssistant';
import EntityPage from '../shared/entity/EntityPage';
import EntityRelatedTable from '../shared/entity/EntityRelatedTable';
import EntityTabs, { EntityTab } from '../shared/entity/EntityTabs';
import { LifeCycleRow } from 'components/LifeCycleBadge';
import { POPULARITY_METADATA_BY_KEY } from 'utils/metrics';
import { PopularityChartCard } from '../shared/entity/chartCards';
import PopularityIndexRelatedEntitiesSectionTable from 'components/DataVis/PopularityIndexRelatedEntitiesTable/PopularityIndexRelatedEntitiesSectionTable';
import ToggleWatch from 'components/Button/ToggleWatch';
import { useCurrentCountry } from 'utils/hooks';
import usePopIndexEntity from '../shared/entity/usePopIndexEntity';
import { useTrackBrandView } from 'utils/hooks/useTrackEntityView';

const METRICS = [
    { key: 'popularity_share', healthStatKey: 'popularity share' },
    POPULARITY_METADATA_BY_KEY.convergence_prc,
];

function PopularityBrandPage({ brandId, controller }) {
    const country = useCurrentCountry();
    const page = usePopIndexEntity({
        entityType: 'brands',
        entityId: brandId,
        country,
        controller,
    });
    const { name, row } = page;

    const healthStats = row?.healthStats;

    useTrackBrandView(DATA_SOURCES.POPULARITY, {
        brandId,
        brandName: name,
        countryName: country?.name || null,
    });

    return (
        <EntityPage
            page={page}
            title={{
                name,
                isLoading: page.isLoading || page.entityQuery.isLoading,
            }}
            actions={
                <ToggleWatch id={brandId} data={{ name, type: 'brand' }} />
            }
            tabs={
                <EntityTabs>
                    <EntityTab name="related categories">
                        <EntityRelatedTable
                            as={PopularityIndexRelatedEntitiesSectionTable}
                            subject="categories"
                            icon="category"
                            title="Related Categories"
                            exportType="related-category"
                            paginateBy="categories"
                            parented
                        />
                    </EntityTab>
                </EntityTabs>
            }
        >
            <div className="flex flex-col gap-3">
                <EntityHeroCard healthStats={healthStats} valueTextSize="base">
                    {row && (
                        <div className="p-4 border-b border-border">
                            <LifeCycleRow data={row} />
                        </div>
                    )}
                </EntityHeroCard>
                <PopularityChartCard
                    metricList={METRICS}
                    healthStats={healthStats}
                    downloadEntity={name}
                />
                <EntityInsightBar
                    entityId={brandId}
                    entityType="brand"
                    entityName={name}
                    country={country?.text_id}
                    week={page.week ? String(page.week) : undefined}
                />
            </div>
        </EntityPage>
    );
}

PopularityBrandPage.displayName = 'PopularityBrand';

export default PopularityBrandPage;
